/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

import { connect } from 'react-redux';
import { change } from 'redux-form';
import {
  CITY,
  STATE,
  ZIP,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import AddressTypeahead from './AddressTypeahead.jsx';

// Street is written through redux-form's own input.onChange, not dispatched here.
const mapDispatchToProps = dispatch => ({
  setAddressFields: (form, values) => {
    [CITY, STATE, ZIP].forEach(name => dispatch(change(form, name, values[name])));
  },
});

export default connect(null, mapDispatchToProps)(AddressTypeahead);
